import {setInitialState} from '../../../utils/reducerOperations';
export const Default=()=>({
    getDistributionDataApi:setInitialState(),
});